import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Composite/ImageCTA/ImageCTA.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.ImageCTA';
export {styles};